/* ==========================================================================
   ACC_BN_LP_103 — Section 01: 24h countdown (resets each local midnight)
   ========================================================================== */
(function (section_name) {
  function pad(n) { return String(n).padStart(2, "0"); }

  function tick(el) {
    var now = new Date();
    var midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0); // next local midnight
    var diff = Math.max(0, midnight - now);
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    el.textContent = pad(h) + ":" + pad(m) + ":" + pad(s);
  }

  function init() {
    var els = document.querySelectorAll("[data-acc103-countdown]");
    if (!els.length) return;
    els.forEach(function (el) {
      tick(el);
      setInterval(function () { tick(el); }, 1000);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})("acc_bn_lp_103_01");
